var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M684.456 690.202H684.387C626.886 670.149 565.006 659.148 500.466 659.148C281.068 659.148 91.7652 785.36 4 967.696H108.764C110.72 964.933 112.706 962.191 114.712 959.468H114.742C112.736 962.201 110.74 964.943 108.774 967.716H202.09C271.585 880.945 379.457 825.049 500.506 825.049C621.554 825.049 729.416 880.945 798.921 967.696H996.951C935.012 839 822.454 738.347 684.466 690.192L684.456 690.202Z",
    fill: "#3A5DEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.63 663.255L354.469 634.735C354.409 634.596 354.349 634.457 354.29 634.318L388.357 558.617L500.231 317.821L502.773 323.296L659.576 663.682C771.003 695.849 870.545 761.086 943.535 850.093L702.193 323.287C702.243 323.992 702.273 324.698 702.322 325.403L686.763 291.696L567.403 32H433.049L298.636 324.459C298.616 324.767 298.596 325.075 298.576 325.383L57.8203 849.258C130.821 760.43 230.302 695.342 341.63 663.255Z",
    fill: "#3A5DEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue-logo.8934f5211c239f3ac2ce38bb2ad1c34c.svg";
export { ForwardRef as ReactComponent };